import ReactGA from 'react-ga4'
import { ButtonDecoSmall, ButtonLineSmall, ButtonRetailer, Button } from './Button'

import axios from 'axios'
import { useEffect, useState } from 'react'

export const Products = () => {
    const gameData = {
        path: 'r-type-tactics',
        steam: '2169930',
    }

    const imagePath = {
        'PlayStation®5': 'ps5',
        'PlayStation®4': 'ps4',
        Xbox: 'xbox',
        'Nintendo Switch™': 'nsw',
        'Nintendo Switch™2': 'ns2',
    }

    const [editions, setEditions] = useState([])
    const [data, setData] = useState([])
    const [activeCharTab, setActiveCharTab] = useState('limited')
    const [platformDeluxe, setPlatformDeluxe] = useState('Nintendo Switch™')

    const FilterRegion = (region, platform) =>
        data.filter((item) => item.region === region && item.edition === 'Deluxe Edition' && item.platform === platform)
    const FilterDigitalRegion = (region, platform) =>
        data.filter((item) => item.region === region && item.edition === 'Deluxe Edition' && item.platform === platform)

    const FilterRegionEdition = (region, platform, edition) =>
        data.filter((item) => item.region === region && item.edition === edition && item.platform === platform)
    const platformReduced = Object.values(data).reduce((acc, curr) => {
        if (curr.platform !== 'PC' && curr.platform !== 'Xbox One' && !acc.includes(curr.platform)) {
            acc.push(curr.platform)
        }
        return acc
    }, [])
    useEffect(() => {
        axios
            .get(`https://www.nisamerica.com/api/game/${gameData.path}`)
            .then((response) => {
                const editions = Object.values(response.data.game.retailerLinks.map((item) => item.edition))
                const data = response.data.game.retailerLinks.map((item) => {
                    return {
                        url: item.url,
                        store: item.store,
                        edition: item.edition,
                        platform: item.platform,
                        region: item.region,
                    }
                })

                setEditions(editions)
                setData(data)
            })
            .catch((error) => {
                // console.log(error)
            })
    }, [])
    return (
        <div id='products' className='max-w-[1000px] container text-white h-full space-y-8  py-20 mt-20  px-4 md:px-0 items-center'>
            <h2 className='text-md tracking-widest my-12 text-center'>Products</h2>{' '}
            <section>
                {' '}
                <div className='bg-white/10 backdrop-blur py-2 px-8 mx-auto my-8'>
                    <h3 className='text-sm tracking-wider'>Limited Edition</h3>
                </div>
                <div className=''>
                    <img
                        className='mx-auto max-w-full'
                        src={`${process.env.PUBLIC_URL}/assets/le-ps5.webp`}
                        alt='deluxe edition ps5 link'
                    />{' '}
                    <div className='flex flex-wrap justify-center gap-4 mt-12 mx-auto'>
                        <Button
                            edition={'Limited'}
                            retailer={'Nisa Online Store'}
                            platform={'ps5'}
                            link={
                                'https://store.nisamerica.com/products/r-type-tactics-i-ii-cosmos?_pos=1&_psq=tac&_ss=e&_v=1.0&variant=40834432663600'
                            }
                        >
                            PlayStation&reg;5
                        </Button>
                        <Button
                            edition={'Limited'}
                            retailer={'Nisa Online Store'}
                            platform={'ps4'}
                            link={
                                'https://store.nisamerica.com/products/r-type-tactics-i-ii-cosmos?_pos=1&_psq=tac&_ss=e&_v=1.0&variant=40834432630832'
                            }
                        >
                            PlayStation&reg;4
                        </Button>{' '}
                        <Button
                            edition={'Limited'}
                            retailer={'Nisa Online Store'}
                            platform={'nsw'}
                            link={
                                'https://store.nisamerica.com/products/r-type-tactics-i-ii-cosmos?_pos=1&_psq=tac&_ss=e&_v=1.0'
                            }
                        >
                            Nintendo Switch&trade;
                        </Button>
                        <p className='bg-stone-700/30 py-8 px-6 m-8'>
                            Important Notice: The Limited Edition of R‑Type Tactics I • II Cosmos for Xbox Series XS has
                            been cancelled. We recommend purchasing the standard digital version.
                        </p>
                    </div>
                </div>
            </section>{' '}
            {/* <section>
                <div className='bg-white/10 backdrop-blur py-2 px-8 mx-auto mt-20 mb-8'>
                    <h3 className='text-sm tracking-wider'>Deluxe Edition</h3>
                </div>
                <div className=''>
                    <img
                        className='mx-auto max-w-full'
                        src={`${process.env.PUBLIC_URL}/assets/tactics-de.jpg`}
                        alt='deluxe edition ps5 link'
                    />{' '}
                    <div className='flex flex-wrap justify-center gap-4 mt-12 mx-auto'>
                        <button className='w-[46%] md:w-[20%]'>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'limited edition',
                                        label: `LE ps5 nisa store`,
                                    })
                                }}
                                className='block bg-rttcred/30 rounded-sm backdrop-blur py-4  text-white/90 cursor-pointer hover:shadow-3xl shadow-2xl hover:duration-700 hover:ease-in-out'
                                target='_blank'
                                rel='noreferrer'
                                href='http://store.nisamerica.com/r-type-tactics-i-ii-cosmos'
                            >
                                <p className='text-sm tracking-wider text-center'>PlayStation&reg;5</p>
                            </a>{' '}
                        </button>{' '}
                        <button className='w-[46%] md:w-[20%]'>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'limited edition',
                                        label: `LE ps4 nisa store`,
                                    })
                                }}
                                className='block bg-rttcred/30 rounded-sm backdrop-blur py-4  text-white/90 cursor-pointer hover:shadow-3xl shadow-2xl hover:duration-700 hover:ease-in-out'
                                target='_blank'
                                rel='noreferrer'
                                href='http://store.nisamerica.com/r-type-tactics-i-ii-cosmos'
                            >
                                <p className='text-sm tracking-wider text-center'>PlayStation&reg;4</p>
                            </a>{' '}
                        </button>{' '}
                        <button className='w-[46%] md:w-[20%]'>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'limited edition',
                                        label: `LE nsw nisa store`,
                                    })
                                }}
                                className='block bg-rttcred/30 rounded-sm backdrop-blur py-4  text-white/90 cursor-pointer hover:shadow-3xl shadow-2xl hover:duration-700 hover:ease-in-out'
                                target='_blank'
                                rel='noreferrer'
                                href='http://store.nisamerica.com/r-type-tactics-i-ii-cosmos'
                            >
                                <p className='text-sm tracking-wider text-center'>Nintendo Switch&trade;</p>
                            </a>{' '}
                        </button>{' '}
                        <button className='w-[46%] md:w-[20%]'>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'limited edition',
                                        label: `LE xbox nisa store`,
                                    })
                                }}
                                className='block bg-rttcred/30 rounded-sm backdrop-blur py-4  text-white/90 cursor-pointer hover:shadow-3xl shadow-2xl hover:duration-700 hover:ease-in-out'
                                target='_blank'
                                rel='noreferrer'
                                href='http://store.nisamerica.com/r-type-tactics-i-ii-cosmos'
                            >
                                <p className='text-sm tracking-wider text-center'>Xbox</p>
                            </a>{' '}
                        </button>{' '}
                    </div>
                </div>
            </section> */}
            <section id='dlxedition' className='mx-auto section-deco max-w-[1000px] px-4 mt-20'>
                <div>
                    <div className='bg-white/10 backdrop-blur py-2 px-8 mx-auto mt-20'>
                        <h3 className='text-sm tracking-wider'>Deluxe Edition</h3>
                    </div>
                </div>{' '}
                <div className='mx-auto mt-12 md:mt-20 w-full'>
                    <div className='flex flex-col lg:flex-row  lg:space-x-4'>
                        <div className='w-full lg:w-1/4 pb-8 lg:pb-20 flex flex-wrap lg:flex-col lg:space-y-4 justify-center lg:justify-start'>
                            <ButtonDecoSmall
                                onClickEvent={() => setPlatformDeluxe('Nintendo Switch™')}
                                active={platformDeluxe === 'Nintendo Switch™'}
                            >
                                Nintendo Switch™
                            </ButtonDecoSmall>{' '}
                            <ButtonDecoSmall
                                onClickEvent={() => setPlatformDeluxe('PlayStation®5')}
                                active={platformDeluxe === 'PlayStation®5'}
                            >
                                PlayStation®5
                            </ButtonDecoSmall>{' '}
                            <ButtonDecoSmall
                                onClickEvent={() => setPlatformDeluxe('PlayStation®4')}
                                active={platformDeluxe === 'PlayStation®4'}
                            >
                                PlayStation®4
                            </ButtonDecoSmall>{' '}
                          
                            <ButtonDecoSmall
                                onClickEvent={() => setPlatformDeluxe('Steam®')}
                                active={platformDeluxe === 'Steam®'}
                            >
                                Steam®
                            </ButtonDecoSmall>{' '}
                        </div>
                        {platformDeluxe === 'Steam®' ? (
                            <div className='md:px-12 w-full'>
                                <iframe
                                    title='phantom brave the lost hero'
                                    src='https://store.steampowered.com/widget/2169930/'
                                    style={{ maxWidth: '900px' }}
                                    frameBorder='0'
                                    width='100%'
                                    height='190'
                                    onClick={() => {
                                        ReactGA.event({
                                            action: 'click',
                                            event: 'link',
                                            category: 'Product',
                                            label: 'Deluxe Ediiton - PC - Steam',
                                        })
                                    }}
                                ></iframe>{' '}
                            </div>
                        ) : (
                            <div className='w-full px-4 pb-8'>
                                <img
                                    className='max-h-[500px] mx-auto'
                                    // src={getImage(`de-${imagePath[platformDeluxe]}.webp`)}
                                    src={`${process.env.PUBLIC_URL}/assets/de-${imagePath[platformDeluxe]}.webp`}
                                    alt={`Deluxe Edition ${imagePath[platformDeluxe]}`}
                                />
                                <div className='text-center mt-4'>
                                    <div className=''>
                                        <ButtonLineSmall text={'North America'} />{' '}
                                        <div className='flex flex-wrap justify-evenly md:justify-around md:gap-4 font-humming'>
                                            {FilterRegion('NA', platformDeluxe).length === 0 ? (
                                                <p className='w-full text-center mt-2 italic'>Coming Soon</p>
                                            ) : (
                                                FilterRegion('NA', platformDeluxe).map((data, i) => (
                                                    <div key={i.data} className='w-[45%] md:w-[23%] lg:w-[22%] mt-2 md:mt-0'>
                                                        <ButtonRetailer
                                                            dataPlatform={data.platform}
                                                            dataUrl={data.url}
                                                            dataStore={data.store}
                                                            gaCategory='Products'
                                                            gaLabel={`Deluxe Edition - ${data.platform} - ${data.store}`}
                                                        />
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>{' '}
                                    {FilterRegion('EU', platformDeluxe).length > 0 && (
                                        <div className='mt-4'>
                                            <ButtonLineSmall text={`Europe`} />
                                            <div className='flex flex-wrap justify-evenly md:justify-around md:gap-4 font-sans'>
                                                {FilterRegion('EU', platformDeluxe).map((data, i) => (
                                                    <div className='w-[45%] md:w-[23vw] lg:w-[28%] mt-2 md:mt-0'>
                                                        <ButtonRetailer
                                                            dataPlatform={data.platform}
                                                            dataUrl={data.url}
                                                            dataStore={data.store}
                                                            gaCategory='Products'
                                                            gaLabel={`Deluxe Edition - ${data.platform} - ${data.store}`}
                                                        />{' '}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    {FilterRegion('ANZ', platformDeluxe).length > 0 && (
                                        <div className='mt-4'>
                                            <ButtonLineSmall text={`Oceania`} />
                                            <div className='flex flex-wrap justify-evenly md:justify-around md:gap-4 font-sans'>
                                                {FilterRegion('ANZ', platformDeluxe).map((data, i) => (
                                                    <div
                                                        className='w-[45%] md:w-[23vw] lg:w-[28%] mt-2 md:mt-0'
                                                        key={i.data}
                                                    >
                                                        <ButtonRetailer
                                                            dataPlatform={data.platform}
                                                            dataUrl={data.url}
                                                            dataStore={data.store}
                                                            gaCategory='Products'
                                                            gaLabel={`Deluxe Edition - ${data.platform} - ${data.store}`}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>{' '}
                                <p className='bg-stone-700/30 py-8 px-6 mt-12'>
                                    Important Notice: The Deluxe Edition of R‑Type Tactics I • II Cosmos for Xbox Series
                                    XS has been cancelled. We recommend purchasing the standard digital version.
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </section>{' '}
        </div>
    )
}
